




import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { GeometryLocation } from "@/interfaces";

import {} from "googlemaps";

@Component
export default class Map extends Vue {
  @Ref("map")
  map!: HTMLDivElement;

  @Prop({ type: Object, required: true })
  center!: GeometryLocation;

  @Prop({ type: Number, default: () => 8 })
  zoom!: number;

  mapInstance!: google.maps.Map<HTMLDivElement>;

  markers: google.maps.Marker[] = [];

  mounted() {
    // eslint-disable-next-line no-undef
    const mapStyle = new google.maps.StyledMapType(
      [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#dadada",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#c9c9c9",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
      ],
      { name: "Mappa stilizzata" },
    );
    // eslint-disable-next-line no-undef
    this.mapInstance = new google.maps.Map(this.map, {
      center: this.center,
      zoom: this.zoom,
      disableDefaultUI: true,
      zoomControl: true,
    });

    this.resize();

    this.mapInstance.mapTypes.set("styled_map", mapStyle);
    this.mapInstance.setMapTypeId("styled_map");
  }

  @Watch("center")
  onCenterChange() {
    this.mapInstance.setCenter(this.center);

    this.removeMarkers();

    // eslint-disable-next-line no-undef
    const marker = new google.maps.Marker({
      position: this.center,
      map: this.mapInstance,
    });

    this.markers = [...this.markers, marker];
  }

  public resize() {
    // eslint-disable-next-line no-undef
    google.maps.event.trigger(this.map, "resize");
  }

  public setCenter(position: GeometryLocation) {
    this.mapInstance.setCenter(position);
  }

  public removeMarkers() {
    this.markers.forEach(marker => {
      marker.setMap(null);
    });

    this.markers = [];
  }

  public addMarker(position: GeometryLocation) {
    // eslint-disable-next-line no-undef
    const marker = new google.maps.Marker({
      position,
      map: this.mapInstance,
    });

    this.markers = [...this.markers, marker];
  }
}
